"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostQueryRequestScale = instanceOfApiPostQueryRequestScale;
exports.ApiPostQueryRequestScaleFromJSON = ApiPostQueryRequestScaleFromJSON;
exports.ApiPostQueryRequestScaleFromJSONTyped = ApiPostQueryRequestScaleFromJSONTyped;
exports.ApiPostQueryRequestScaleToJSON = ApiPostQueryRequestScaleToJSON;
exports.ApiPostQueryRequestScaleToJSONTyped = ApiPostQueryRequestScaleToJSONTyped;
/**
 * Check if a given object implements the ApiPostQueryRequestScale interface.
 */
function instanceOfApiPostQueryRequestScale(value) {
    return true;
}
function ApiPostQueryRequestScaleFromJSON(json) {
    return ApiPostQueryRequestScaleFromJSONTyped(json, false);
}
function ApiPostQueryRequestScaleFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fields': json['fields'] == null ? undefined : json['fields'],
    };
}
function ApiPostQueryRequestScaleToJSON(json) {
    return ApiPostQueryRequestScaleToJSONTyped(json, false);
}
function ApiPostQueryRequestScaleToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fields': value['fields'],
    };
}
